import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '@app/services';
import { environment } from '@env/environment';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  imports: [],
})
export class SignUpComponent implements OnInit, OnDestroy {
  env = environment;

  form: UntypedFormGroup;
  submitted = false;

  componentActive = true;

  // If Is Agency
  agencyName: string;

  constructor(
    private router: Router,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    if (this.loginService.user?.isConfirmed) {
      this.router.navigate(['/']);
      return;
    }
    this.agencyName = this.loginService.user?.agencyName ?? undefined;

    // this.app.title('Sign Up For Secure Bids');
    // this.form = new UntypedFormGroup({
    //   id: new FormControl<number>(0),
    //   email: new FormControl<string>(this.loginService.loggedInUser.email),
    //   firstName: new FormControl<string>('', Validators.required),
    //   lastName: new FormControl<string>('', Validators.required),

    //   phone: new FormControl<string>('', Validators.required),
    //   extension: new FormControl<number | ''>(''),
    //   liabilityRelease: new FormControl<boolean>(false, [
    //     Validators.requiredTrue
    //   ]),
    //   confirmPolicy: new FormControl<boolean>(false, [Validators.requiredTrue])
    // });
    // if (this.loginService.loggedInVendor) {
    //   this.form.addControl(
    //     'companyName',
    //     new FormControl<string>('', Validators.required)
    //   );
    // }

    // this.form.get('email').disable();

    // this.route.data
    //   .pipe(
    //     takeWhile(() => this.componentActive),
    //     filter((val) => {
    //       return this.loginService.loggedInAgency;
    //     }),
    //     switchMap(() => {
    //       this.app.loading = true;
    //       return this.route.params;
    //     }),
    //     switchMap((params) => {
    //       return this.userService.getUnconfirmedUser();
    //     })
    //   )
    //   .subscribe({
    //     next: (res) => {
    //       this.agencyName = res.agencyName;
    //       this.app.loading = false;

    //       this.form.controls.id.setValue(res.id);
    //       this.form.controls.firstName.setValue(res.contactInfo.firstName);
    //       this.form.controls.lastName.setValue(res.contactInfo.lastName);
    //       this.form.controls.email.setValue(res.contactInfo.email);
    //       // split the phone number
    //       let phone = res.contactInfo.phone.split('x');
    //       this.form.controls.phone.setValue(phone[0].trim());
    //       //needs testing - backend
    //       if (phone.length > 1) {
    //         this.form.controls.extension.setValue(phone[1].trim());
    //       }
    //     },
    //     error: (error) => {
    //       this.app.loading = false;

    //       if (error.status === 400) {
    //         this.router.navigate(['/', 'agency-account-confirmed'], {
    //           queryParams: { alreadyConfirmed: 'true' }
    //         });
    //       }
    //     }
    //   });
  }

  ngOnDestroy() {
    this.componentActive = false;
  }
}
